import {
    Box,
    Button,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    SimpleGrid,
    Stack
} from "@chakra-ui/react";
import React from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Colors from "../../../assets/colors/Colors";
import call from "../../../assets/images/call.svg";
import email from "../../../assets/images/email.svg";
import password from "../../../assets/images/password.svg";
import user from "../../../assets/images/user.svg";
import {
    GrubErrorMessage,
    GrubFormButton,
    GrubInput,
    GrubProgress,
    GrubTitleText,
} from "../../../components/index";
import * as Constants from "../../../constants/Constants";
import { WithRouter } from "../../../navigators/WithRouter";
import AuthInput from "../components/AuthInput";
import BackIconButton from "../components/BackIconButton";
import { useSignUp } from "../hooks/useSignUp";

const SignUp = (props) => {
    const {
        formik,
        address,
        errorMessage,
        isSubmittingRef,
        addressRef,
        loading,
        isFocused,
        nameRef,
        serverError,
        keyboardOpen,
        handleKeyDown,
        handleAddressChange,
        handleSubmit,
        setErrorMessage,
    } = useSignUp(props);
    return (
        <>
            <Modal
                isOpen={props.isOpen}
                size="sm"
                isCentered={!keyboardOpen}
                closeOnEsc={false}
                closeOnOverlayClick={false}
                overflowY="auto"
                scrollBehavior="inside"
                blockScrollOnMount={false}
            >
                <ModalOverlay />
                <ModalContent
                    borderRadius="0.63rem"
                    my={{ base: 0, md: "3.75rem" }}
                >
                    {loading && <GrubProgress />}
                    <ModalHeader
                        pb={0}
                        pl={{ base: "2.56rem", md: "2.56rem" }}
                        pr={{ base: "2.56rem", md: "2.56rem" }}
                        pt={{ base: "1.88rem", md: "1.88rem" }}
                    >
                        <BackIconButton
                            iconButton={true}
                            onClick={(e) => {
                                e.preventDefault();
                                props.handleBackButton();
                            }}
                        />
                    </ModalHeader>
                    <ModalBody
                        pl={{ base: "2.56rem", md: "2.56rem" }}
                        pr={{ base: "2.56rem", md: "2.56rem" }}
                        pb={{ base: "4.13rem", md: "4.13rem" }}
                    >
                        <GrubTitleText
                            isLabelText={true}
                            color={Colors.posTextInfo}
                            name={"Sign Up"}
                        />
                        <Button
                            variant="link"
                            onClick={(e) => {
                                e.preventDefault();
                                props.handleBackButton();
                            }}
                            fontStyle="normal"
                            fontWeight={300}
                            fontSize="0.75rem"
                            lineHeight="0.94rem"
                            letterSpacing="-0.01rem"
                            color={Colors.primeTaxInfo}
                        >
                            Have an existing account?
                        </Button>
                        <Stack mt={{ base: "1.5rem", md: "1.5rem" }}>
                            <SimpleGrid
                                gap={{ base: 2 }}
                                columns={{ base: 1, md: 2 }}
                            >
                                <Stack flex="1" width="100%">
                                    <GrubInput
                                        id="name"
                                        placeholder={"First Name"}
                                        autoFocus={isFocused}
                                        handleInputChange={formik.handleChange}
                                        width={{ base: "18.63rem", md: "9rem" }}
                                        inputValue={formik.values.name || ""}
                                        handleBlur={(e) => {
                                            setTimeout(() => {
                                                if (nameRef.current) {
                                                    formik.setFieldValue(
                                                        "name",
                                                        formik.values.name.trim()
                                                    );
                                                    formik.handleBlur(e);
                                                    isSubmittingRef.current = true;
                                                }
                                            }, Constants.TIMEOUT_DELAY);
                                        }}
                                        posInputGroup={true}
                                        darkPlaceholder={true}
                                        onKeyDown={(e) =>
                                            handleKeyDown(e, "last_name")
                                        }
                                        background={Colors.posviewbgcolor}
                                        inputType={"text"}
                                        inputError={
                                            formik.touched.name &&
                                            formik.errors.name
                                        }
                                    >
                                        <Image src={user} width={"0.99rem"} />
                                    </GrubInput>
                                    {formik.touched.name &&
                                        formik.errors.name && (
                                            <GrubTitleText
                                                isErrorText={true}
                                                color={
                                                    Colors.posCancleButtonRed
                                                }
                                                name={formik.errors.name}
                                            />
                                        )}
                                </Stack>
                                <Stack flex="1" width="100%">
                                    <GrubInput
                                        id="last_name"
                                        placeholder={"Last Name"}
                                        handleInputChange={formik.handleChange}
                                        width={{ base: "18.63rem", md: "9rem" }}
                                        inputValue={
                                            formik.values.last_name || ""
                                        }
                                        handleBlur={(e) => {
                                            setTimeout(() => {
                                                formik.setFieldValue(
                                                    "last_name",
                                                    formik.values.last_name.trim()
                                                );
                                                formik.handleBlur(e);
                                                isSubmittingRef.current = true;
                                            }, Constants.TIMEOUT_DELAY);
                                        }}
                                        posInputGroup={true}
                                        darkPlaceholder={true}
                                        onKeyDown={(e) =>
                                            handleKeyDown(e, "email")
                                        }
                                        background={Colors.posviewbgcolor}
                                        inputType={"text"}
                                        inputError={
                                            formik.touched.last_name &&
                                            formik.errors.last_name
                                        }
                                    >
                                        <Image src={user} width={"0.99rem"} />
                                    </GrubInput>
                                    {formik.touched.last_name &&
                                        formik.errors.last_name && (
                                            <GrubTitleText
                                                isErrorText={true}
                                                color={
                                                    Colors.posCancleButtonRed
                                                }
                                                name={formik.errors.last_name}
                                            />
                                        )}
                                </Stack>
                            </SimpleGrid>
                            <GrubInput
                                id="email"
                                placeholder={"Email Address"}
                                handleInputChange={formik.handleChange}
                                inputValue={formik.values.email || ""}
                                handleBlur={(e) => {
                                    setTimeout(() => {
                                        formik.setFieldValue(
                                            "email",
                                            formik.values.email.trim()
                                        );
                                        formik.handleBlur(e);
                                        isSubmittingRef.current = true;
                                    }, Constants.TIMEOUT_DELAY);
                                }}
                                width={"18.63rem"}
                                posInputGroup={true}
                                darkPlaceholder={true}
                                onKeyDown={(e) => handleKeyDown(e, "phone")}
                                background={Colors.posviewbgcolor}
                                inputType={"text"}
                                inputError={
                                    formik.touched.email && formik.errors.email
                                }
                            >
                                <Image src={email} width={"0.99rem"} />
                            </GrubInput>
                            {formik.touched.email && formik.errors.email && (
                                <GrubTitleText
                                    isErrorText={true}
                                    color={Colors.posCancleButtonRed}
                                    name={formik.errors.email}
                                />
                            )}
                            <GrubInput
                                id="phone"
                                placeholder={"Phone Number"}
                                handleInputChange={formik.handleChange}
                                inputValue={formik.values.phone || ""}
                                handleBlur={(e) => {
                                    setTimeout(() => {
                                        formik.setFieldValue(
                                            "phone",
                                            formik.values.phone.trim()
                                        );
                                        formik.handleBlur(e);
                                        isSubmittingRef.current = true;
                                    }, Constants.TIMEOUT_DELAY);
                                }}
                                width={"18.63rem"}
                                posInputGroup={true}
                                darkPlaceholder={true}
                                onKeyDown={(e) => handleKeyDown(e, "password")}
                                background={Colors.posviewbgcolor}
                                inputType={"text"}
                                inputError={
                                    formik.touched.phone && formik.errors.phone
                                }
                                disabled={props.phoneNumber}
                            >
                                <Image src={call} width={"0.99rem"} />
                            </GrubInput>
                            {formik.touched.phone && formik.errors.phone && (
                                <GrubTitleText
                                    isErrorText={true}
                                    color={Colors.posCancleButtonRed}
                                    name={formik.errors.phone}
                                />
                            )}
                            <AuthInput
                                id="password"
                                name="password"
                                placeholder="Password"
                                inputValue={formik.values.password}
                                handleInputChange={formik.handleChange}
                                width={"18.63rem"}
                                handleBlur={(e) => {
                                    setTimeout(() => {
                                        formik.setFieldValue(
                                            "password",
                                            formik.values.password.trim()
                                        );
                                        formik.handleBlur(e);
                                        isSubmittingRef.current = true;
                                    }, Constants.TIMEOUT_DELAY);
                                }}
                                inputError={
                                    formik.touched.password &&
                                    formik.errors.password
                                }
                                darkPlaceholder={true}
                                onKeyDown={(e) =>
                                    handleKeyDown(e, "confirmPassword")
                                }
                                showToggle={true}
                                leftIcon={
                                    <Image src={password} width={"1rem"} />
                                }
                            />
                            {formik.touched.password &&
                                formik.errors.password && (
                                    <GrubTitleText
                                        isErrorText={true}
                                        color={Colors.posCancleButtonRed}
                                        name={formik.errors.password}
                                    />
                                )}
                            <AuthInput
                                id="confirmPassword"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                inputValue={formik.values.confirmPassword}
                                handleInputChange={formik.handleChange}
                                width={"18.63rem"}
                                handleBlur={(e) => {
                                    setTimeout(() => {
                                        formik.setFieldValue(
                                            "confirmPassword",
                                            formik.values.confirmPassword.trim()
                                        );
                                        formik.handleBlur(e);
                                        isSubmittingRef.current = true;
                                    }, Constants.TIMEOUT_DELAY);
                                }}
                                inputError={
                                    formik.touched.confirmPassword &&
                                    formik.errors.confirmPassword
                                }
                                darkPlaceholder={true}
                                onKeyDown={(e) => handleKeyDown(e, "address")}
                                showToggle={true}
                                leftIcon={
                                    <Image src={password} width={"1rem"} />
                                }
                            />
                            {formik.touched.confirmPassword &&
                                formik.errors.confirmPassword && (
                                    <GrubTitleText
                                        isErrorText={true}
                                        color={Colors.posCancleButtonRed}
                                        name={formik.errors.confirmPassword}
                                    />
                                )}
                            <Box
                                style={{ marginBottom: "2%" }}
                                width={"18.63rem"}
                            >
                                <GooglePlacesAutocomplete
                                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                                    selectProps={{
                                        placeholder: "Address *",
                                        isClearable: true,
                                        value: address,
                                        id: "address",
                                        onChange: (val) => {
                                            addressRef.current = val;
                                            handleAddressChange(val);
                                        },
                                        onBlur: () => {
                                            if (addressRef.current == "") {
                                                setErrorMessage(
                                                    Constants.USER_ADDRESS_REQUIRED
                                                );
                                            }
                                        },
                                        onKeyDown: (e) =>
                                            handleKeyDown(e, "submit"),
                                        styles: {
                                            control: (base, state) => ({
                                                ...base,
                                                fontSize: "0.94rem",
                                                borderColor: errorMessage
                                                    ? Colors.posCancleButtonRed
                                                    : state.isFocused
                                                    ? Colors.taxInfo
                                                    : Colors.posInputBorder,
                                                boxShadow: errorMessage
                                                    ? "0rem 0rem 0rem 0.188rem " +
                                                      Colors.badgeError
                                                    : state.isFocused
                                                    ? "0rem 0rem 0rem 0.188rem " +
                                                      Colors.inputHover
                                                    : "",
                                                "&:hover": {
                                                    borderColor: errorMessage
                                                        ? Colors.posCancleButtonRed
                                                        : "",
                                                    boxShadow: "none",
                                                },
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                color: "#010048",
                                                fontSize: "0.75rem",
                                                LineHeight: "1.17rem",
                                                fontWeight: 300,
                                                fontStyle: "normal",
                                                letterSpacing: "-0.02em",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                bottom: "100%",
                                                top: "auto",
                                                margin: "0 0 8px",
                                            }),
                                            menuList: (base) => ({
                                                ...base,
                                                // maxHeight: '13rem'
                                            }),
                                        },
                                    }}
                                    autocompletionRequest={{
                                        componentRestrictions: {
                                            country: ["us"],
                                        },
                                    }}
                                />
                                {errorMessage && (
                                    <GrubTitleText
                                        isErrorText={true}
                                        mt={2}
                                        color={Colors.posCancleButtonRed}
                                        name={errorMessage}
                                    />
                                )}
                            </Box>
                        </Stack>
                        {(serverError?.message?.length > 0 ||
                            props.signUpMessage?.message?.length > 0) && (
                            <GrubErrorMessage
                                errorMessage={
                                    serverError?.message ||
                                    props?.signUpMessage?.message
                                }
                                isError={
                                    serverError?.error === true ||
                                    props?.signUpMessage?.error === true ||
                                    false
                                }
                                width={"auto"}
                            />
                        )}
                        <Box mt={{ base: "2.44rem", md: "2.44rem" }}>
                            <GrubFormButton
                                isDisabled={loading}
                                bg={Colors.posTextInfo}
                                buttonsubmit={"Sign Up"}
                                width={"18.6rem"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmit();
                                }}
                            />
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default WithRouter(SignUp);
